import { useState } from "react";
import {
  Users,
  Video,
  Film,
  Palette,
  Sparkles,
  PenTool,
  Camera,
  FileText,
  Music,
  AudioLines,
  ChevronDown,
  Play,
} from "lucide-react";

const services = [
  { 
    id: "film-crew",
    icon: Users, 
    name: "Film Crew", 
    description: "Tim produksi profesional untuk kebutuhan film dan video Anda",
    fullDescription: "Tim Film Crew kami terdiri dari profesional berpengalaman yang siap mendukung setiap aspek produksi film Anda. Dari sutradara, kameramen, hingga tim teknis — kami menyediakan layanan lengkap untuk memastikan produksi berjalan lancar.",
    portfolio: [
      { title: "Film Crew 1", thumbnail: "/image/FilmCrew/PPPL3764.jpg", type: "image" },
      { title: "Film Crew 2", thumbnail: "/image/FilmCrew/PPPL3775.jpg", type: "image" },
      { title: "Film Crew 3", thumbnail: "/image/FilmCrew/PPPL4155.jpg", type: "image" },
      { title: "Film Crew 4", thumbnail: "/image/FilmCrew/PPPL4190.jpg", type: "image" },
      { title: "Film Crew 5", thumbnail: "/image/FilmCrew/PPPL4333.jpg", type: "image" },
      { title: "Film Crew 6", thumbnail: "/image/FilmCrew/PPPL4667.jpg", type: "image" },
      { title: "Film Crew 7", thumbnail: "/image/FilmCrew/PPPL5042.jpg", type: "image" },
      { title: "Film Crew 8", thumbnail: "/image/FilmCrew/PPPL5063.jpg", type: "image" },
    ]
  },
  { 
    id: "videography",
    icon: Video, 
    name: "Videography", 
    description: "Pengambilan gambar sinematik berkualitas tinggi",
    fullDescription: "Layanan videografi kami menghadirkan kualitas sinematik untuk setiap proyek. Dengan peralatan modern dan teknik profesional, kami menangkap setiap momen dengan sempurna.",
    portfolio: [
      { title: "Videography 1", thumbnail: "/image/Videography/PPPL4026.jpg", type: "image" },
      { title: "Videography 2", thumbnail: "/image/Videography/PPPL4058.jpg", type: "image" },
      { title: "Videography 3", thumbnail: "/image/Videography/PPPL4116.jpg", type: "image" },
      { title: "Videography 4", thumbnail: "/image/Videography/PPPL4569.jpg", type: "image" },
      { title: "Videography 5", thumbnail: "/image/Videography/PPPL4596.jpg", type: "image" },
    ]
  },
  { 
    id: "video-editing",
    icon: Film, 
    name: "Video Editing", 
    description: "Penyuntingan video profesional dengan sentuhan kreatif",
    fullDescription: "Tim editor kami mengubah footage mentah menjadi karya visual yang memukau. Dengan keahlian storytelling dan teknis editing, kami menciptakan video yang engaging dan profesional.",
    portfolio: [
      { title: "Short Film Edit", thumbnail: "https://images.unsplash.com/photo-1738566061689-bd301bf81a0f?w=600&q=80", type: "image" },
      { title: "Music Video Edit", thumbnail: "https://images.unsplash.com/photo-1646115059023-c473b1f9ad1f?w=600&q=80", type: "image" },
    ]
  },
  { 
    id: "color-grading",
    icon: Palette, 
    name: "Color Grading", 
    description: "Koreksi warna sinematik untuk mood yang sempurna",
    fullDescription: "Color grading adalah sentuhan akhir yang membuat video Anda tampil berbeda. Kami menciptakan look dan mood yang sesuai dengan visi kreatif proyek Anda.",
    portfolio: [
      { title: "Cinematic Grade", thumbnail: "https://images.unsplash.com/photo-1738566061689-bd301bf81a0f?w=600&q=80", type: "image" },
      { title: "Commercial Grade", thumbnail: "https://images.pexels.com/photos/6892721/pexels-photo-6892721.jpeg?w=600", type: "image" },
    ]
  },
  { 
    id: "vfx",
    icon: Sparkles, 
    name: "Visual Effects", 
    description: "Efek visual berkualitas untuk produksi Anda",
    fullDescription: "Tim VFX kami menciptakan efek visual yang memukau, dari compositing sederhana hingga efek kompleks. Kami membawa imajinasi Anda menjadi kenyataan visual.",
    portfolio: [
      { title: "VFX Breakdown", thumbnail: "https://images.unsplash.com/photo-1646115059023-c473b1f9ad1f?w=600&q=80", type: "image" },
      { title: "Motion Graphics", thumbnail: "https://images.pexels.com/photos/6892721/pexels-photo-6892721.jpeg?w=600", type: "image" },
    ]
  },
  { 
    id: "graphic-design",
    icon: PenTool, 
    name: "Graphic Design", 
    description: "Desain grafis kreatif untuk berbagai kebutuhan",
    fullDescription: "Layanan desain grafis kami mencakup branding, poster film, thumbnail, dan berbagai kebutuhan visual lainnya. Kami menciptakan desain yang memorable dan impactful.",
    portfolio: [
      { title: "Brand Identity", thumbnail: "https://images.pexels.com/photos/6892721/pexels-photo-6892721.jpeg?w=600", type: "image" },
      { title: "Poster Design", thumbnail: "https://images.pexels.com/photos/8088383/pexels-photo-8088383.jpeg?w=600", type: "image" },
    ]
  },
  { 
    id: "photography",
    icon: Camera, 
    name: "Photography", 
    description: "Fotografi profesional untuk setiap momen",
    fullDescription: "Tim fotografer kami menangkap momen dengan mata artistik dan teknik profesional. Dari portrait hingga event photography, kami menghasilkan foto berkualitas tinggi.",
    portfolio: [
      { title: "Photography 1", thumbnail: "/image/Photography/PPPL4093.jpg", type: "image" },
      { title: "Photography 2", thumbnail: "/image/Photography/PPPL4268.jpg", type: "image" },
      { title: "Photography 3", thumbnail: "/image/Photography/PPPL4271.jpg", type: "image" },
      { title: "Photography 4", thumbnail: "/image/Photography/PPPL4787.jpg", type: "image" },
      { title: "Photography 5", thumbnail: "/image/Photography/PPPL5088.jpg", type: "image" },
    ]
  },
  { 
    id: "scriptwriting",
    icon: FileText, 
    name: "Scriptwriting", 
    description: "Penulisan naskah kreatif yang memikat",
    fullDescription: "Tim penulis kami menciptakan naskah yang compelling dan engaging. Dari konsep hingga dialog, kami membangun cerita yang resonan dengan audiens Anda.",
    portfolio: [
      { title: "Short Film Script", thumbnail: "https://images.pexels.com/photos/7586141/pexels-photo-7586141.jpeg?w=600", type: "image" },
      { title: "Commercial Script", thumbnail: "https://images.pexels.com/photos/8088383/pexels-photo-8088383.jpeg?w=600", type: "image" },
    ]
  },
  { 
    id: "music-scoring",
    icon: Music, 
    name: "Music Scoring", 
    description: "Komposisi musik original untuk proyek Anda",
    fullDescription: "Musik adalah jiwa dari setiap video. Tim komposer kami menciptakan score original yang memperkuat emosi dan pesan dalam karya visual Anda.",
    portfolio: [
      { title: "Film Score", thumbnail: "https://images.pexels.com/photos/30229850/pexels-photo-30229850.jpeg?w=600", type: "image" },
      { title: "Commercial Jingle", thumbnail: "https://images.pexels.com/photos/7586141/pexels-photo-7586141.jpeg?w=600", type: "image" },
    ]
  },
  { 
    id: "sound-design",
    icon: AudioLines, 
    name: "Sound Design", 
    description: "Desain audio berkualitas untuk pengalaman immersive",
    fullDescription: "Sound design yang baik membuat perbedaan besar. Kami menciptakan soundscape yang immersive, dari foley hingga ambient sound, untuk pengalaman audio yang sempurna.",
    portfolio: [
      { title: "Film Sound Design", thumbnail: "https://images.pexels.com/photos/30229850/pexels-photo-30229850.jpeg?w=600", type: "image" },
      { title: "Podcast Production", thumbnail: "https://images.pexels.com/photos/7586141/pexels-photo-7586141.jpeg?w=600", type: "image" },
    ]
  },
];

export default function ReferensiPage() {
  const [expandedId, setExpandedId] = useState(null);

  const toggleExpand = (id) => {
    setExpandedId(expandedId === id ? null : id);
  };

  return (
    <div className="min-h-screen pt-16 sm:pt-20 bg-[#0A1628]">
      {/* Background Pattern */}
      <div className="fixed inset-0 opacity-5 pointer-events-none">
        <div
          className="absolute inset-0"
          style={{
            backgroundImage: `radial-gradient(circle at 2px 2px, white 1px, transparent 0)`,
            backgroundSize: "40px 40px",
          }}
        />
      </div>

      <div className="relative z-10 py-8 sm:py-12 lg:py-16">
        <div className="max-w-5xl mx-auto px-4 sm:px-6 lg:px-8">
          {/* Header */}
          <div className="text-center mb-8 sm:mb-12">
            <span
              data-testid="referensi-badge"
              className="inline-block px-3 sm:px-4 py-1.5 sm:py-2 bg-[#E8761A]/10 border border-[#E8761A]/30 rounded-full text-[#E8761A] text-xs sm:text-sm font-medium tracking-wider uppercase mb-4 sm:mb-6"
            >
              Layanan Kami
            </span>
            <h1
              data-testid="referensi-title"
              className="text-2xl sm:text-3xl lg:text-5xl font-bold text-white mb-4 sm:mb-6"
            >
              <span className="text-[#E8761A]">Referensi</span> & Portfolio
            </h1>
            <div className="section-divider mx-auto mb-4 sm:mb-6" />
            <p className="text-white/60 text-sm sm:text-base max-w-2xl mx-auto px-2">
              Klik pada layanan untuk melihat detail dan portfolio
            </p>
          </div>

          {/* Accordion Services */}
          <div className="flex flex-col gap-6 sm:gap-8 lg:gap-10">
            {services.map((service) => (
              <div
                key={service.id}
                data-testid={`service-accordion-${service.id}`}
                className="bg-white/5 border border-white/10 rounded-xl overflow-hidden transition-all duration-300 hover:border-[#E8761A]/30"
              >
                {/* Accordion Header - Always Visible */}
                <button
                  onClick={() => toggleExpand(service.id)}
                  data-testid={`service-btn-${service.id}`}
                  className="w-full flex items-center justify-between p-4 sm:p-5 lg:p-6 text-left group"
                >
                  <div className="flex items-center gap-3 sm:gap-4">
                    <div className="w-10 h-10 sm:w-12 sm:h-12 bg-[#E8761A]/10 rounded-xl flex items-center justify-center group-hover:bg-[#E8761A]/20 transition-colors duration-300">
                      <service.icon className="w-5 h-5 sm:w-6 sm:h-6 text-[#E8761A]" />
                    </div>
                    <div>
                      <h3 className="text-white font-semibold text-sm sm:text-base lg:text-lg group-hover:text-[#E8761A] transition-colors">
                        {service.name}
                      </h3>
                      <p className="text-white/50 text-xs sm:text-sm hidden sm:block">
                        {service.description}
                      </p>
                    </div>
                  </div>
                  <ChevronDown 
                    className={`w-5 h-5 sm:w-6 sm:h-6 text-white/50 transition-transform duration-300 ${
                      expandedId === service.id ? "rotate-180 text-[#E8761A]" : ""
                    }`}
                  />
                </button>

                {/* Accordion Content - Expandable */}
                <div
                  className={`transition-all duration-500 ease-in-out ${
                    expandedId === service.id ? "max-h-[70vh] sm:max-h-[80vh] opacity-100 overflow-y-auto" : "max-h-0 opacity-0 overflow-hidden"
                  }`}
                >
                  <div className="px-4 sm:px-5 lg:px-6 pb-4 sm:pb-5 lg:pb-6 border-t border-white/10">
                    {/* Description */}
                    <div className="py-4 sm:py-5">
                      <h4 className="text-white font-medium mb-2 sm:mb-3 text-sm sm:text-base">Tentang Layanan</h4>
                      <p className="text-white/60 text-xs sm:text-sm leading-relaxed">
                        {service.fullDescription}
                      </p>
                    </div>

                    {/* Portfolio Grid */}
                    <div>
                      <h4 className="text-white font-medium mb-3 sm:mb-4 text-sm sm:text-base">Portfolio</h4>
                      <div className="grid grid-cols-1 sm:grid-cols-2 gap-3 sm:gap-4">
                        {service.portfolio.map((item, index) => (
                          <div
                            key={index}
                            data-testid={`portfolio-${service.id}-${index}`}
                            className="group relative aspect-video rounded-lg overflow-hidden border border-white/10"
                          >
                            <img
                              src={item.thumbnail}
                              alt={item.title}
                              className="w-full h-full object-cover transition-transform duration-500 group-hover:scale-105"
                            />
                            <div className="absolute inset-0 bg-gradient-to-t from-[#0A1628]/90 via-[#0A1628]/20 to-transparent" />
                            <div className="absolute inset-0 flex items-center justify-center opacity-0 group-hover:opacity-100 transition-opacity duration-300">
                              <div className="w-10 h-10 sm:w-12 sm:h-12 bg-[#E8761A] rounded-full flex items-center justify-center shadow-lg">
                                <Play className="w-4 h-4 sm:w-5 sm:h-5 text-white ml-0.5" fill="white" />
                              </div>
                            </div>
                            <div className="absolute bottom-2 sm:bottom-3 left-2 sm:left-3 right-2 sm:right-3">
                              <h5 className="text-white font-medium text-xs sm:text-sm">{item.title}</h5>
                            </div>
                          </div>
                        ))}
                      </div>
                    </div>

                    {/* CTA */}
                    <div className="mt-4 sm:mt-6 pt-4 border-t border-white/10">
                      <a
                        href="https://wa.me/6289516500862"
                        target="_blank"
                        rel="noopener noreferrer"
                        data-testid={`cta-${service.id}`}
                        className="btn-primary inline-flex items-center gap-2 text-xs sm:text-sm px-4 py-2 sm:px-6 sm:py-3"
                      >
                        Diskusikan Proyek
                      </a>
                    </div>
                  </div>
                </div>
              </div>
            ))}
          </div>

          {/* Portfolio Videos Grid */}
          <div className="mt-12 sm:mt-16 lg:mt-20">
            <div className="text-center mb-8 sm:mb-12">
              <span
                data-testid="portfolio-videos-badge"
                className="inline-block px-3 sm:px-4 py-1.5 sm:py-2 bg-[#E8761A]/10 border border-[#E8761A]/30 rounded-full text-[#E8761A] text-xs sm:text-sm font-medium tracking-wider uppercase mb-4 sm:mb-6"
              >
                Portfolio Videos
              </span>
              <h3
                data-testid="portfolio-videos-title"
                className="text-lg sm:text-xl lg:text-2xl font-semibold text-white mb-4 sm:mb-6 text-center"
              >
                Karya <span className="text-[#E8761A]">Kami</span>
              </h3>
              <div className="section-divider mx-auto" />
            </div>

            <div className="grid grid-cols-1 sm:grid-cols-2 gap-4 sm:gap-6">
              {[
                {
                  id: "EOiQyb5CcMY",
                  title: "Short Film — Langkah Kedua Gema Emas (DISPORAPAR KALBAR)",
                  client: "DISPORAPAR KALBAR",
                },
                {
                  id: "wxo7dltY2RE",
                  title: "Film Pendek — AndaI Ibu Bisa Terbang (DISPORAPAR KALBAR)",
                  client: "DISPORAPAR KALBAR",
                },
                {
                  id: "swSDSPDmENc",
                  title: "Company Profile — RSUD Dokter Soedarso 2025",
                  client: "RSUD dr. Soedarso Kalimantan Barat",
                },
                {
                  id: "eVSaMyJbxjg",
                  title: "Dokumenter — Mandau: Sebilah Senjata Seribu Cerita",
                  client: "BP Kebudayaan Kalimantan Barat",
                },
                {
                  id: "rgI5vI2rAac",
                  title: "Music Video — IBU (Zaliqa Rifya ft. Galih Getarkan)",
                  client: "Zaliqa Rifya",
                },
                {
                  id: "Usac3Z5Ewws",
                  title: "Film Pendek — H7 2020",
                  client: "Voult",
                },
                {
                  id: "kqcWqcqwxZY",
                  title: "TVC — JNE Ramadhan 2025",
                  client: "Voult",
                },
              ].map((video) => (
                <div
                  key={video.id}
                  data-testid={`portfolio-video-${video.id}`}
                  className="bg-white/5 border border-white/10 rounded-xl overflow-hidden hover:border-[#E8761A]/30 transition-all duration-300 group"
                >
                  <div className="aspect-video relative overflow-hidden">
                    <img
                      src={`https://i.ytimg.com/vi/${video.id}/hqdefault.jpg`}
                      alt={video.title}
                      className="w-full h-full object-cover transition-transform duration-500 group-hover:scale-105"
                    />
                    <div className="absolute inset-0 bg-gradient-to-t from-[#0A1628]/90 via-transparent to-transparent" />
                    <div className="absolute inset-0 flex items-center justify-center opacity-0 group-hover:opacity-100 transition-opacity duration-300">
                      <div className="w-12 h-12 sm:w-14 sm:h-14 bg-[#E8761A] rounded-full flex items-center justify-center shadow-lg shadow-[#E8761A]/30">
                        <Play className="w-5 h-5 sm:w-6 sm:h-6 text-white ml-0.5" fill="white" />
                      </div>
                    </div>
                    <a
                      href={`https://www.youtube.com/watch?v=${video.id}`}
                      target="_blank"
                      rel="noopener noreferrer"
                      className="absolute inset-0 z-10"
                    >
                      <span className="sr-only">Watch {video.title}</span>
                    </a>
                  </div>
                  <div className="p-3 sm:p-4">
                    <h4 className="text-white font-medium text-sm leading-snug line-clamp-2 mb-1">
                      {video.title}
                    </h4>
                    <p className="text-white/50 text-xs">{video.client}</p>
                  </div>
                </div>
              ))}
            </div>
          </div>

          {/* Featured Video */}
          <div className="mt-12 sm:mt-16 lg:mt-20">
            <h3
              data-testid="featured-video-title"
              className="text-lg sm:text-xl lg:text-2xl font-semibold text-white mb-4 sm:mb-6 text-center"
            >
              Featured: <span className="text-[#E8761A]">Company Profile</span>
            </h3>
            <div className="max-w-4xl mx-auto">
              <div className="video-container rounded-xl sm:rounded-2xl overflow-hidden border border-white/10 shadow-2xl shadow-black/30">
                <iframe
                  src="https://www.youtube.com/embed/swSDSPDmENc"
                  title="Oerang Borneo Film - Company Profile"
                  allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                  allowFullScreen
                  data-testid="featured-video-iframe"
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
